export default {
  methods: {
    clearFormValidationError($event) {
      if ($event.target.name) {
        this.form.errors.clear($event.target.name);
      }
    },
  },
};
